import { render, staticRenderFns } from "./company-item.vue?vue&type=template&id=4446204e&scoped=true"
import script from "./company-item.vue?vue&type=script&lang=js"
export * from "./company-item.vue?vue&type=script&lang=js"
import style0 from "./company-item.vue?vue&type=style&index=0&id=4446204e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446204e",
  null
  
)

export default component.exports